import React, { useState, useEffect, useContext, useMemo } from "react";
import URLstateContext from "../../../../provider/CommonContext";
import { Col, Container, Row } from 'react-bootstrap';
import './PeerComparisonMarket.css';
import { useLocalStorage } from "../../../utils/useLocalStorage";
import Pagination from '../../../CommonUI/Pagination/Pagination';
import {  useParams } from "react-router-dom";
import CompanyProfileOptions from "../../CompanyProfileOptions/CompanyProfileOptions";
import { Vortex } from 'react-loader-spinner'

function PeerComparison() {
    const [showResults, setShowResults] = useState(false);
    const [suggestions, setSuggestions] = useState([]);
    const [setTextval, setText] = useState([]);
    const [cocode, setcocode] = useLocalStorage("cocode", "");
    const [co_code, setco_code] = useState([]);
    const [compCode, setCompCode] = useState('');
    const [nameCom, setNameCom] = useState([]);
    let DataFilter = [];
    let getval = [];
    let matchcomp = [];
    const { getCompName } = useParams();
    const [data, setData] = useState([]);
    // const [valuebtn, setValueBtn] = useState("desc");
    // const [valueLi, setValueLi] = useState("Day");
    const [dataGroup, setDataGroup] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [groupValue, setGroupValue] = useState("BSE");
    // const [groupIndex, setGroupIndex] = useState("BSE_SENSEX");
    // const [groupIndexNSE, setGroupIndexNSE] = useState("NIFTY");
    const { BaseURL } = useContext(URLstateContext);
    const [loadingshow, setloadingshow] = useState(false);
    let getData, getDataGroup, eleBtn, eleBtnLoose, eleLi;
    let PageSize = 8;

    // useEffect(() => {
    //     setTimeout(() => {
    //         eleBtn.classList.add('active');
    //         eleLi.classList.add('active');
    //     })
    // }, [])
    useEffect(() => {
        setloadingshow(true)
        if(co_code != ''){
        if (groupValue === "BSE") {
            const getUrl = BaseURL + "PeerComparison";
            fetch(`${getUrl}/${groupValue}/${co_code}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    // console.log(getData, "getData")
                })
                .catch((error) => {
                });
        } else {
            const getUrl = BaseURL + "PeerComparison";
            fetch(`${getUrl}/${groupValue}/${co_code}`)
                .then((response) => response.json())
                .then((data) => {
                    getData = data.data;
                    setData(getData);
                    setloadingshow(false);
                    //console.log(getData, "getData")
                })
                .catch((error) => {
                });
        }
    }
        const getUrlGroup = BaseURL + "GroupMaster";
        fetch(`${getUrlGroup}/${groupValue}`)
            .then((response) => response.json())
            .then((dataG) => {
                getDataGroup = dataG.data;
                setDataGroup(getDataGroup);
                //console.log(getDataGroup, "getDataGroup")
            })
            .catch((error) => {
            });

    }, [groupValue,co_code]);



    const currentTableData = useMemo(() => {
        if (data != null && data != []) {
            const firstPageIndex = (currentPage - 1) * PageSize;
            const lastPageIndex = firstPageIndex + PageSize;
            if (data != null && data != []) {
                if (data.length > 0) {
                    return data.slice(firstPageIndex, lastPageIndex);
                }
            }
        }
    }, [currentPage, data]);
    useEffect(() => {
        const getUrlchart = BaseURL + "getCo_Code";
        fetch(`${getUrlchart}/${getCompName}`)
            .then((response) => response.json())
            .then((data) => {
                setco_code(data.data[0]["co_code"]);
                setNameCom(data.data[0]["lname"]);
                //console.log(data)
            })
            .catch((error) => {
                //console.log("not found the api");
            });
    }, []);
    const routeChange = (event) => {
        const compcocode = event.currentTarget.dataset.id;
        const compcode_array = compcocode.split('-');
        const getCoCodeId = compcode_array[0].replace(/ /g, '-').replace('&', 'and').replace('+', '');
        setcocode(compcode_array[1]);
        window.open("/stocks/" + getCoCodeId.toLowerCase(), '_blank');
    };
    // const onChangeHandler = event => {
    //     let matches = [];
    //     setText(event.target.value);
    //     if (setTextval.length > 1) {
    //         Loadcompany(setTextval);
    //     }
    //     else {
    //         DataFilter = [];
    //         setSuggestions(DataFilter);
    //     }

    // };
    // function Loadcompany(setTextval) {
    //     setShowResults(true);
    //     const getSectorListUrl = BaseURL + "companysearch/" + setTextval;

    //     fetch(`${getSectorListUrl}`)
    //         .then((response) => response.json())
    //         .then((data) => {
    //             const myrepo = data.data;

    //             getval = myrepo;
    //             for (var i = 0; i < getval.length; i++) {
    //                 DataFilter.push({
    //                     CompName: getval[i]['lname'],
    //                     COCODE: getval[i]['Co_Code'],
    //                     Exchange: getval[i]['Exchange']
    //                 });
    //             }

    //             matchcomp = DataFilter;
    //             setSuggestions(matchcomp);

    //         })
    //         .catch((error) => {
    //             console.log(error);
    //         });
    // }
    // const companyClick = (paramcode, paramname, paramexchange) => {
    //     setShowResults(false);
    //     setCompCode(paramcode);
    // }

    // const handleClick = () => {
    //     if (groupValue === "BSE") {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);

    //                 // console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     } else {
    //         const getUrl = BaseURL + "PeerComparison";
    //         fetch(`${getUrl}/${groupValue}/${compCode}`)
    //             .then((response) => response.json())
    //             .then((data) => {
    //                 getData = data.data;
    //                 setData(getData);
    //                 //console.log(getData, "getData")
    //             })
    //             .catch((error) => {
    //             });
    //     }

    // }

    return (
        <>
             <div class="col-12 p-0 breadcrum ">
                <ul>
                    <li><a href="/">Home</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/market/stocks">Stocks</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li><a href="/CompanyProfile/Get-Quotes">Company Profile</a> <i class="fa fa-angle-right" aria-hidden="true"></i></li>
                    <li>Peer Comparison</li>
                </ul>
            </div>
            <Container>
                <Row>
                    <Col sm={12}>
                        <section className='share-loser-sc'>
                            <div className='score-header'>
                                <h2><span>Peer Comparison</span></h2>
                            </div>
                            <CompanyProfileOptions compOption="Peer Comparison"/>
                            <div>
                                <h4 className="text-center comp-name">{(nameCom != null) ? nameCom :''}</h4>
                            </div>
                            <div className="table-class">
                            <div className='share-right'>
                                <div className='share-inner-select'>
                                    <select onChange={(event) => { setGroupValue(event.target.value); }}>
                                        <option value="BSE" selected>BSE</option>
                                        <option value="NSE">NSE</option>
                                    </select>
                                </div>
                            </div>
                            {/* <hr className="hrPeer"></hr> */}
                            <div className='DayUp-table table-responsive'>
                                <table className='table'>
                                    <thead>
                                        <tr>
                                            <th className='text-left'>Company Name</th>
                                            <th className='text-right'>PRICE Rs.</th>
                                            <th className='text-right'>MCAP Cr.</th>
                                            <th className='text-right'>P/B</th>
                                            <th className='text-right'>P/ERs.</th>
                                            <th className='text-right'>EPS%</th>
                                            <th className='text-right'>ROE%</th>
                                            <th className='text-right'>ROCE%</th>
                                            <th className='text-right'>P/S</th>
                                            <th className='text-right'>EV/EBITDA</th>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {currentTableData && currentTableData.map(
                                            ({ lname, currprice, mcap, Price_BookValue, PriceEarning, EPS, ROE, ROCE, P_S, EV_EBITDA,CO_CODE }) => (
                                                <tr>
                                                    <td className="text-left"><h6 onClick={routeChange} data-id={lname + '-' + CO_CODE}>{lname}</h6></td>
                                                    <td className="text-right">{currprice.toFixed(2)}</td>
                                                    <td className="text-right">{mcap.toFixed(2)}</td>
                                                    <td className="text-right">{Price_BookValue.toFixed(2)}</td>
                                                    <td className="text-right">{PriceEarning.toFixed(2)}</td>
                                                    <td className="text-right">{EPS.toFixed(2)}</td>
                                                    <td className="text-right">{ROE.toFixed(2)}</td>
                                                    <td className="text-right">{ROCE.toFixed(2)}</td>
                                                    <td className="text-right"> {(P_S != null) ? P_S.toFixed(2) : P_S = 0}</td>
                                                    <td className="text-right"> {(EV_EBITDA != null) ? EV_EBITDA.toFixed(2) : EV_EBITDA = 0}</td>
                                                </tr>
                                            ))}
                                    </tbody>
                                </table>
                                {loadingshow ? <div className="textcentervertex">
                                                        <Vortex
                                                            visible={true}
                                                            height="80"
                                                            width="80"
                                                            ariaLabel="vortex-loading"
                                                            wrapperStyle={{}}
                                                            wrapperClass="vortex-wrapper"
                                                            colors={['#0473ea', '#0473ea', '#0473ea', '#39d800', '#39d800', '#39d800']}
                                                        />
                                                        <div className="model_popup">Please Wait...</div>
                                                    </div> : ""
                                                    }
                                </div>
                            </div>
                            {(data != null && data != []) ?
                                <Pagination
                                    className="pagination-bar_peer"
                                    currentPage={currentPage}
                                    totalCount={(data.length != null) ? data.length : 0}
                                    pageSize={PageSize}
                                    onPageChange={page => setCurrentPage(page)}
                                /> : <p className="errorPeer"> No Data Found !!! </p>}

                        </section>
                    </Col>
                </Row>
            </Container>
        </>
    );
}

export default PeerComparison;

